export interface WeaponSpec {
  readonly id: string;
  readonly name: string;
  readonly headMass: number;
  readonly headRadius: number;
  readonly bodyMass: number;
  readonly bodyRadius: number;
  readonly haftLength: number;
  readonly links: number;
  readonly compliance: number;
  readonly tau: number;
  readonly maxSpeed: number;
  readonly maxAccel: number;
  readonly headFriction: number;
  readonly bodyFriction: number;
  readonly gripFriction: number;
  readonly breakSpeed: number;
  readonly breakSpan: number;
  readonly gripFloor: number;
  readonly plantedGrip: number;
  readonly plantedFriction: number;
  readonly damageCoefficient: number;
  readonly minSpeed: number;
  readonly refSpeed: number;
  readonly damageExponent: number;
}

export const MAUL: WeaponSpec = {
  id: 'maul',
  name: 'Maul',
  headMass: 46,
  headRadius: 0.68,
  bodyMass: 11,
  bodyRadius: 0.42,
  haftLength: 2.3,
  links: 1,
  compliance: 0.0000012,
  tau: 0.13,
  maxSpeed: 30,
  maxAccel: 190,
  headFriction: 0.15,
  bodyFriction: 1.9,
  gripFriction: 30,
  breakSpeed: 9,
  breakSpan: 9,
  gripFloor: 0.035,
  plantedGrip: 0.012,
  plantedFriction: 30,
  damageCoefficient: 1,
  minSpeed: 3.5,
  refSpeed: 18,
  damageExponent: 1.5
};

export const FLAIL: WeaponSpec = {
  ...MAUL,
  id: 'flail',
  name: 'Flail',
  headMass: 38,
  headRadius: 0.6,
  haftLength: 3.2,
  links: 2,
  compliance: 0.00002,
  tau: 0.15,
  maxAccel: 165,
  headFriction: 0,
  damageCoefficient: 1.12
};

export const SPEAR: WeaponSpec = {
  ...MAUL,
  id: 'spear',
  name: 'Spear',
  headMass: 20,
  headRadius: 0.4,
  haftLength: 3.5,
  links: 1,
  compliance: 0.0000004,
  tau: 0.09,
  maxSpeed: 38,
  maxAccel: 300,
  headFriction: 0,
  damageCoefficient: 1.5,
  minSpeed: 3,
  refSpeed: 16
};

export const WEAPONS: Readonly<Record<string, WeaponSpec>> = {
  maul: MAUL,
  flail: FLAIL,
  spear: SPEAR
};
